import { makeRequest } from 'utils/requestLogger';

// This endpoint deletes a student participation and denies them access to the live discussion.
// Student is kicked out
export default (discussionId, payload) =>
    makeRequest(
        'post',
        `/api/live_discussions/${discussionId}/remove-students`, payload
    );



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/removeStudents.js